import React, { useEffect } from "react";
import "./index.css";
import { Form, Input, Button, message } from "antd";
import { Redirect, useParams } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../../application/store";
import { DocumentTitle, AuthForm } from "../../components";
import I18n from "../../i18n";
import { logger } from "../../../utils";
import { checkAuthentication } from "../../../application/auth-slice";
import { setCode, verifyCode } from "../../../application/verfiy-code-slice";
import { VerificationCodeType } from "../../../domain";
import { useQuery } from "../../hooks";
import { editPhoneNumber } from "../../../application/login-register-slice";
import { isMobile } from "react-device-detect";

const { Item, useForm } = Form;

type RouteParams = { type: VerificationCodeType; phone: string };

export default function VerifyCode() {
  const verificationCodeLength = 6;
  const { type, phone } = useParams<RouteParams>();
  const query = useQuery();
  const { code, loading, failure, token } = useAppSelector(
    (state) => state.verifyCode
  );
  const dispatch = useAppDispatch();
  const [form] = useForm();

  const submit = async () => {
    try {
      await form.validateFields();
      dispatch(verifyCode(phone, type));
    } catch (error) {
      logger.error(error);
    }
  };

  useEffect(() => {
    if (loading === "failed") {
      failure?.maybeMap({
        wrongVerificationCodeFailure: () => { },
        orElse: () => message.error(I18n.general.networkError),
      });
    }
  }, [loading, failure]);

  if (loading === "succeeded") {
    const back = query.get("back");
    if (type === "login") {
      dispatch(checkAuthentication());
      return <Redirect to={back ? back : "/"} />;
    }
    if (type === "register") {
      return <Redirect to={`/register-form/${phone}?back=${back}`} />;
    }
    if (type === "forgot-password") {
      return (
        <Redirect to={`/change-password/${phone}/${token}?back=${back}`} />
      );
    }
  }

  const isLoading = loading === "pending";
  return (
    <DocumentTitle title={I18n.verifyCode.pageTitle}>
      <div style={{ margin: isMobile ? '15px' : 0 }}>
        <AuthForm
          title={I18n.title}
          subtitle={I18n.verifyCode.title}
          description={I18n.verifyCode.description.replace("{phone}", phone)}
        >
          <Form
            form={form}
            onFinish={submit}
            fields={[{ name: "code", value: code }]}
          >
            <Item
              name="code"
              validateStatus={failure?.maybeMap({
                wrongVerificationCodeFailure: () => "error",
                orElse: () => undefined,
              })}
              help={failure?.maybeMap({
                wrongVerificationCodeFailure: () => I18n.verifyCode.wrongCode,
                orElse: () => undefined,
              })}
              rules={[
                {
                  required: true,
                  message: I18n.verifyCode.verificationCodeEmptyError,
                  validateTrigger: "onSubmit",
                },
                {
                  len: verificationCodeLength,
                  message: I18n.verifyCode.verificationCodeShortError,
                  validateTrigger: "onSubmit",
                },
              ]}
            >
              <Input
                required={true}
                placeholder={I18n.verifyCode.verificationCode}
                className={code === "" ? "" : "veridy-code-form-input"}
                maxLength={verificationCodeLength}
                disabled={isLoading}
                spellCheck={false}
                onChange={(value) => {
                  dispatch(setCode(value.target.value));
                  form.setFields([{ name: "code", value: code }]);
                }}
              />
            </Item>
            <Item>
              <Button type="primary" block onClick={submit} loading={isLoading}>
                {I18n.verifyCode.submit}
              </Button>
            </Item>
          </Form>
          <Button
            type="link"
            block
            size="small"
            style={{ marginBottom: 16 }}
            disabled={isLoading}
            loading={isLoading}
            onClick={() => dispatch(editPhoneNumber())}
          >
            تصحیح شماره موبایل
          </Button>
        </AuthForm>
      </div>
    </DocumentTitle>
  );
}
